<script>
  import { default as Navigation } from '../../../components/menu/Navigation.svelte';
  import { onMount } from 'svelte';
  import { Router, Link, link, Route, navigate } from "svelte-routing";
  
  export let active = 'index';
  export let apps = {};
  
  let frame = undefined;
  let url = "/";
  let active_menu = [];
  
  const listOfApps = () => Object.keys(apps);
  
  $: showApp(active)
  
  function hasAppMenu() {
    return active && apps[active] && apps[active]['menu'] && apps[active].menu.length;
  }
  function appMenu() {
    return hasAppMenu() ? apps[active].menu : [];
  }
  function activeMenuLink() {
    return hasAppMenu() ? apps[active].menu[0].link : '';
  }
  
  function appName(a) {
    if (a === null || a == undefined) a = active;
    if (a === null || a == undefined || !apps[a]) return "";
    return apps[a].name;
  }
  
  function appLink(a) {
    if (a === null || a == undefined) a = active;
    if (a === null || a == undefined || !apps[a]) return "/";
    return apps[a].link;
  }
  
  function appLayout(a) {
    if (a === null || a == undefined) a = active;
    if (a === null || a == undefined || !apps[a]) return false;
    return apps[a]['layout'];
  }
  
  function showApp() {
    //navigate("/"+active, { replace: true });
    //apps[active].link = event.node.href;
    active_menu = appMenu();
    if (frame == undefined) return;
    frame.contentWindow.location.href = appLink();
  }
  
  function storePathname() {
    window.location.hash = frame.contentWindow.location.pathname;
  }
</script>
<Router url='{url}'>
<div class='col-md-3 col-lg-2'>
<select bind:value='{active}' class='navbar' on:blur='{showApp}'>
{#each listOfApps() as app}
<option value='{app}'>{appName(app)}</option>
{/each}
</select>
{#if appMenu()}
<div class='left_col scroll-view'>
<Navigation target='{active}'></Navigation>
</div>
{/if}
</div>
<div class='col-md-9 col-lg-10 p-0 h-98 bg-light' role='main'>
<iframe bind:this='{frame}' class='appframe' frameborder='0' id='{active}App' src='{appLink()}' title='{'xx'}'></iframe>
</div>
</Router>
